import type { MyEstimateGroup } from '@massilia/contracts'

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

/**
 * Toutes les demandes de devis du compte, avec leurs propositions. Les statuts
 * et `canAct` sont calculés serveur : le front n'a qu'à les afficher.
 */
export const useGetMyEstimatesQuery = (enabled = true) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<MyEstimateGroup[]>('/me/estimates')
      return response.data
    },
    queryKey: meKeys.estimates,
  })
